<template>
    <div style="width: 90%; text-align: initial; margin: 5%;">
        <modal identifier="leaveeditquestion" ref="question" :question="question" :cancelText="cancelText" :confirmText="confirmText" :showTrigger="false"  v-on:onConfirm="okClicked()" v-on:onCancel="cancelClicked()" confirmButtonClass="green"/>
        <div v-if="devices_loaded">
            <div class="row" style="padding-top: 20px;">
                <div class="col s6">
                    <h4>{{$t('inspection.title')}}</h4>
                </div>
                <div class="col s2" style=" display: table-cell; vertical-align: middle; ">
                    <h5 style="line-height: 160%;">{{$t('inspection.date')}}:</h5>
                </div>
                <div class="col s3" style=" display: table-cell; vertical-align: middle; ">
                    <input type="date" v-model="inspection.date" />
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    <table class="addresses">
                        <tr>
                            <th width="50%" style="text-transform: uppercase;">{{$t('inspection.company')}}</th>
                            <th width="50%" style="text-transform: uppercase;">{{$t('inspection.place_name')}}</th>
                        </tr>
                        <tr>
                            <td>
                                {{inspection.company_name}}<br />
                                {{inspection.company_address.street}}<br />
                                {{inspection.company_address.postal_code}} {{inspection.company_address.city}}
                            </td>
                            <td>
                                {{inspection.place_name}}<br />
                                {{inspection.place_address.street}}<br />
                                {{inspection.place_address.postal_code}} {{inspection.place_address.city}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col s1" style="padding-top: 5px;">
                    {{$t('inspection.inspector')}}</div>
                <div class="col s2" style="padding-top: 5px;">
                    <select v-model="inspection.worker_id" style="height: 32px;">
                        <option v-for="worker in workers" :value="worker.value">{{worker.name}}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col s1" style="padding-top: 5px;">
                    {{$t('inspection.inspectors')}}:</div>
                <div class="col s2" style="padding-top: 5px;">
                    <selector v-model="inspection.worker_ids" :items="workers" identifier="workerslist"></selector>
                </div>
            </div>
            <div class="row">
                <div class="col s6" style="padding-bottom: 15px;">
                    <template v-if="inspection.with_notions">
                        {{$t('inspection.more_on_sanitary_conditions')}}
                    </template>
                </div>
            </div>
            <div class="row">
                <div class="col s6">
                    <h6><b>{{$t('inspection.pests_activity_outside')}}</b></h6>
                </div>
            </div>
            <div class="row">
                <div class="col s1">
                    {{$t('inspection.activity')}}:
                </div>
                <div class="col s2">
                    <select v-model="inspection.safety_conditions">
                        <option v-for="(item, index) in act_levels" v-bind:value="index">{{item}}</option>
                    </select>
                </div>
            </div>
            <div class="row" v-for="(inspectionspest, index) in inspection.inspection_pests"  v-if="inspectionspest._destroy != true">
                <div class="col s1">
                     {{$t('inspection.pests')}}:
                </div>
                <div class="col s2">
                    <select v-model="inspectionspest.pest_id">
                        <optgroup v-for="(item, key, index) in pestGroups" :label="key">
                            <option v-for="pest in item" v-bind:value="pest.id">{{pest.name}}</option>
                        </optgroup>
                    </select>
                </div>
                <div class="col s1">
                    {{$t('inspections.notices')}}:
                </div>
                <div class="col s2">
                    <input type="text" v-model="inspectionspest.notices" />
                </div>
                <div class="col s1">
                    <button class="btn-small red" v-on:click="removeInspectionPest(inspectionspest)">{{$t('menu.buttons.delete')}}</button>
                </div>
            </div>
            <div class="row" v-if="inspection.safety_conditions">
                <div class="col s12">
                    <button class="btn btn-small solidgreen" v-on:click="inspection.inspection_pests.push({})">{{$t('inspections.add_pest')}}</button>
                </div>
            </div>
            <div style="height: 25px;" />
            <div class="row">
                <div class="col s2" v-for="photo in inspection.pests_photos">
                    <div style="width: fit-content; margin: auto;"><img :src="photo.image_thumb" /></div>
                    <p>{{photo.notices}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    <h6><b>{{$t('inspection.inspection_title')}}</b></h6>
                </div>
            </div>
            <template v-for="properties_casting, gname in property_groups">
                <div class="row" v-if="gname != null && gname !='null' ">
                    <div class="col s6" style="padding-top: 15px;padding-left: 0px;">
                        <div class="col s6">
                            <h6>
                                <p>{{$t('inspection.zone')}}: {{gname}}</p>
                            </h6>
                            <hr />
                        </div>
                    </div>
                </div>
                <template v-for='pc in properties_casting'>
                    <div class="row" v-if="pc.items.length > 0">
                        <div class="col s6" style="padding-top: 15px;">
                            <b>{{pc.device_category.name}}</b>
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 15px; margin-bottom: 5px; border-bottom: 2px solid black;" v-if="pc.items.length > 0">
                        <div class="col s1">
                            {{$t('inspection.number_long')}}
                        </div>
                        <div class="col s2" style="text-transform: uppercase;">
                            {{$t('inspection.activity')}}
                        </div>
                        <div class="col s2">
                            {{$t('inspection.pests')}}
                        </div>
                        <div class="col s1">
                            {{$t('inspection.cleanup')}}
                        </div>
                        <div class="col s1">
                           {{$t('inspection.substance_replaced')}}
                        </div>
                        <div class="col s5">
                            {{$t('inspections.notices')}}
                        </div>
                    </div>
                    <div class="row" v-for="(item, index) in pc.items" style="padding-top: 15px; padding-bottom: 15px; border-bottom: 1px solid black;"  :class="{ hidden: item._destroy }"   :key="item.device_id">
                        <div class="col s1">
                            {{item.number}}
                        </div>
                        <div class="col s2">
                            <template v-if="item.conditions != null">
                                {{long_act_levels[item.conditions]}}
                            </template>
                            <template v-else>
                                -------
                            </template>
                        </div>
                        <div class="col s2">
                             <template v-if="item.conditions != null">
                                <template v-for="property_pest in item.property_pests">
                                    <template v-if="property_pest._destroy != true">
                                        {{pestsdict[property_pest.pest_id]}}
                                    </template>
                                </template>
                            </template>
                            <template v-else>
                                -------
                            </template>
                        </div>
                        <div class="col s1">
                            <template v-if="item.conditions != null">
                                <span v-bind:class="{'emptygreen': item.cleanup, 'emptygray': !item.cleanup}">{{$t('inspection.yes')}}</span>
                                <span v-bind:class="{'emptygreen': !item.cleanup, 'emptygray': item.cleanup}">{{$t('inspection.no')}}</span>
                            </template>
                            <template v-else>
                                -------
                            </template>
                        </div>
                        <div class="col s1">
                            <template v-if="item.conditions != null">
                                <span v-bind:class="{'emptygreen': item.substance_replaced, 'emptygray': !item.substance_replaced}">{{$t('inspection.yes')}}</span>
                                <span v-bind:class="{'emptygreen': !item.substance_replaced, 'emptygray': item.substance_replaced}">{{$t('inspection.no')}}</span>
                            </template>
                            <template v-else>
                                -------
                            </template>
                        </div>
                        <div class="col s3">
                            <template v-if="item.safety_conditions == 2"><p>{{$t('inspection.broken')}} ({{item.notions}})</p></template>
                            <template v-else-if="item.safety_conditions == 1"><p>{{$t('inspection.need_replace')}} ({{item.notions}})</p></template>
                            <template v-else><p>{{item.notions}}</p></template>
                            <template v-if="item.got_sample"><p>{{$t('inspection.got_to_marking')}}</p></template>
                            <template v-if="item.kind != undefined && item.kind != 2">{{problem_kinds[item.kind]}} ({{item.inactivate_cause}})</template>
                        </div>
                        <div class="col s2" style="display: inline-flex; gap: 10px;">
                            {{item._destroy}}
                            <button class="btn-small red" v-on:click="removeProperty(item)">{{$t('menu.buttons.delete')}}</button>
                            <propertyproblemmodal
                                v-bind:propertyProblemRow="item" 
                                :pestGroups="pestGroups" 
                                :substanceGroups="substanceGroups" 
                                :substanceUsages="place.substance_usages" 
                                :withSeal="place.with_seal" 
                                :dev_types="dev_types"
                                :criteria="inspection.criteria"
                                :devices="devices"
                                v-if="devices_loaded"
                                v-on:save="rowSaved"
                            />
                        </div>
                    </div>
                </template>
            </template>
            <div class="row" v-if="leftDevices.length > 0">
                <div class="col s3" style="padding-top: 5px; line-height: 3;">
                    {{$t('inspection.add_property')}}
                </div>
                <div class="col s4" style="padding-top: 5px;">
                    <select v-model="selectedAdds">
                        <option value="all">{{$t('inspection.all_devices')}}</option>
                        <option value="selected">{{$t('inspection.selected_devices')}}</option>
                        <option v-for="dc in leftDeviceCategories" :value="'allFromDeviceCategory' + dc.value">{{$t('inspection.all')}} {{dc.name}}</option>
                        <option v-for="zone in leftDeviceZones" :value="'allFromZone'+zone.id">{{$t('inspection.devices_in_zone')}} {{zone.name}}</option>
                    </select>
                </div>
                <div class="col s2" style="padding-top: 5px;" v-if="selectedAdds == 'selected'">
                    <selector v-if="devices_loaded" v-model="selectedDevices" :items="leftDevicesOptions" identifier="devslist"></selector>
                </div>
                <div class="col s2">
                    <button class="btn-small solidgreen" style="margin-top: 10px;" v-on:click="addDevices()">{{$t('inspection.mass_add_property')}}</button>
                </div>
            </div>
            <div class="row">
                <div class="col s6" style="padding-top: 5px;">
                    <b>{{$t('inspection.trends')}}:</b>
                    <font color="red">▲</font> - {{$t('inspection.ascending')}} <font color="gray">●</font> - {{$t('inspection.constant')}} <font color="green">▼</font> - {{$t('inspection.descending')}}
                </div>
            </div>
            <div class="row" style="padding-top: 15px;">
                <div class="col s12">
                    <h6><b>{{$t('inspection.substances_tresholds')}}</b></h6>
                </div>
            </div>
            <template v-for="criterium in inspection.criteria">
                <template v-for="criterium_category in criterium.categories">
                    <div class="row" style="padding-top: 15px;">
                        <template v-if="criterium.zone_name != null">
                            <div class="col s12">{{criterium_category.name}}, {{$t('inspection.zone')}}: {{criterium.zone_name}}</div>
                        </template>
                        <template v-if="criterium.zone_name == null || criterium.zone_name == undefined">
                            <div class="col s12">{{criterium_category.name}}, {{$t('inspection.no_zone')}}</div>
                        </template>
                    </div>
                    <criterium :criterium=criterium_category :from_zone="criterium.zone_name != null" :pests="pestslist" :has_disaster_point="criterium.has_disaster_point"></criterium>
                </template>
            </template>
            <div class="row" style="margin-top: 25px;">
                <div class="col s2" v-for="photo in inspection.property_photos">
                    <div style="width: fit-content; margin: auto;"><img :src="photo.image_thumb" /></div>
                    <p><b>{{photo.device_number}}</b></p>
                    <p>{{photo.notices}}</p>
                </div>
                <div class="col s2" v-for="photo in inspection.problem_photos">
                    <div style="width: fit-content; margin: auto;"><img :src="photo.image_thumb" /></div>
                    <p><b>{{photo.device_number}}</b></p>
                    <p>{{photo.notices}}</p>
                </div>
            </div>
            <div class="row" style="padding-top: 15px;" v-if="inspection.dosage_table.length > 0">
                <div class="col s6">
                    <b>{{$t('inspection.substances_usages')}}</b>
                </div>
            </div>
            <div class="row" v-if="inspection.dosage_table.length > 0">
                <div class="col s12">
                    <table>
                        <th>{{$t('inspection.name')}}</th>
                        <th>{{$t('inspection.amount')}}</th>
                        <th>{{$t('inspection.usage')}}</th>
                        <th>{{$t('inspection.replaced_suplemented')}}</th>
                        <tr v-for="dose in inspection.dosage_table">
                            <td>{{dose.name}}</td>
                            <td>{{dose.applied}} {{dose.unit}}</td>
                            <td>{{dose.consumed==0.0 ? "-------" : dose.consumed}} {{dose.consumed==0.0 ? "" : dose.unit}}</td>
                            <td>{{dose.replaced}} {{dose.unit}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col s6">
                    <b>{{$t('inspection.sanitary_conditions')}}</b>
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    <table>
                        <tr>
                            <th>{{$t('inspection.comments_recommendations')}}:</th>
                            <th></th>
                            <th></th>
                        </tr>
                        <tr v-for="recommendation in recommendations" :class="inspection.recommendations_resolved_ids.indexOf(recommendation.id) > -1 ? 'resolved' : ''" v-if="recommendation != undefined && recommendation._destroy != true">
                            <td style="min-width: 40vw;">{{recommendation.about}}</td>
                            <td style="min-width: 40vw;">{{$t('inspection.recommendation')}}: {{recommendation.solution}}
                            
                            </td>
                            <td>
                                <label v-if="recommendation.editable != true">
                                    <input type="checkbox" :value="recommendation.id" v-model="inspection.recommendations_resolved_ids"/>
                                    <span></span>
                                </label>
                            </td>
                        </tr>
                        <tr v-for="recommendation in inspection.recommendations" :class="inspection.recommendations_resolved_ids.indexOf(recommendation.id) > -1 ? 'resolved' : ''">
                            <td style="min-width: 35vw;">{{recommendation.about}}</td>
                            <td style="min-width: 35vw;">{{$t('inspection.recommendation')}}: {{recommendation.solution}}
                            </td>
                            <td style="min-width: 15vw;">
                                <recommendationeditor v-if="recommendation.editable" v-bind:recommendation="recommendation" v-on:saved="recommendationSaved()" v-on:removed="removeRecommendation(recommendation)"/>
                               
                            </td>
                        </tr>
                    </table>
                    <button class="btn-small solidgreen" style="margin-top: 10px;" v-on:click="addRecommendation()">{{$t('inspection.add_recommendation')}}</button>
                </div>
            </div>
            <div class="row">
                <div class="col s6">
                    {{$t('inspection.full_list_onrecommendations')}}
                </div>
            </div>
            <div class="row" v-if="inspection.answers.length > 0">
                <div class="col s6">
                    <h6>{{$t('inspection.sanitary_questions')}}</h6>
                </div>
            </div>
            <div class="row" v-if="inspection.answers.length > 0" style="padding-bottom: 15px;">
                <div class="col s12">
                    <table>
                        <tr>
                            <th style="min-width: 50%;">{{$t('inspection.question')}}</th>
                            <th style="min-width: 50%;">{{$t('inspection.answer')}} </th>
                        </tr>
                        <template v-for="answer in inspection.answers">
                            <tr v-if="answer._destroy != true">
                                <td>{{answer.question}}</td>
                                <td>
                                    <select v-model="answer.yesno">
                                        <option value="true">{{$t('inspection.yes')}}</option>
                                        <option value="false">{{$t('inspection.no')}}</option>
                                    </select>
                                </td>
                                <td><button class="btn-small red" v-on:click="removeAnswer(answer)">{{$t('menu.buttons.delete')}}</button></td>
                            </tr>
                        </template>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col s2" v-for="(photo, index) in inspection.media" v-if="photo._destroy != true" style="width: fit-content;margin: auto;height: 100px;">
                    <button class="removephoto" v-on:click="removePhoto(photo)"><i class="material-icons">close</i></button>
                    <div style="width: fit-content; margin: auto;">
                        <img style="max-height: 80px" v-if="photo.image && photo.image.thumb" :src="photo.image.thumb.url" />
                        <img :class="'photo'+index" style="max-height: 80px" v-if="photo.image == undefined"/>
                    </div>
                    <p>{{photo.notices}}</p>
                      <input
                        v-if="photo.image == undefined"
                        type="file"
                        id="photo"
                        name="photo"
                        multiple="true"
                        @change="setFile(photo, $event.target.name, $event.target.files)"
                        accept="image/png, image/jpeg"
                     />
                </div>
            </div>
            <div class="row">
                <div class="col s2"><button class="btn-small solidgreen" v-on:click="addPhoto()">{{$t('inspection.add_photo')}}</button></div>
            </div>
            <div class="row" v-if="inspection.inner">
                <div class="col s6">
                    <h6><b>{{$t('inspection_procedures.inner_inspections')}}</b></h6>
                </div>
            </div>
            <div class="row" v-if="inspection.inner">
                <div class="col s12">
                    {{inspection.inner_notices}}
                </div>
            </div>
            <div class="row" v-if="inspection.inner">
                <div class="col s6">
                    <h6><b>{{$t('inspections.notices')}}</b></h6>
                </div>
            </div>
            <div class="row">
                <div class="col s12">{{inspection.additional_pests ? inspection.additional_pests : "-----"}}</div>
            </div>
            <div class="row">
                <div class="col s6" style="padding-left: 15px;">{{$t('inspection.inspected_by')}}: {{inspection.worker}}</div>
                <div class="col s6" style="padding-left: 15px;">{{$t('inspection.accepted_by')}}: {{inspection.acceptor}}</div>
            </div>
            <div class="row">
                <div class="col s6 label">
                    <div style="border: 1px solid black; margin: 5px; margin-right: 15px;"><img style="width: 50%; height: 200px;" :src="`${inspection.worker_signature}`" v-if="inspection.worker_signature != undefined"></div>
                </div>
                <div class="col s6 label">
                    <div style="border: 1px solid black; margin: 5px; margin-right: 15px;" v-if="inspection.signature != undefined"><img style="width: 50%; height: 200px;" :src="`data:image/png;base64,${inspection.signature}`"></div>
                </div>
            </div>
            <div class="row">
                <div class="col s6 label">
                </div>
                <div class="col s6 label">
                    <button class="btn green adder" v-on:click="saveInspection()">
                        <template v-if="!saving">{{$t('inspection.save')}}</template>
                    </button>
                </div>
            </div>
        </div>
        <div v-if="!devices_loaded">
            <div class="container" style="width: 3%; margin: auto;">
                <div class="preloader-wrapper active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
export default {
    data: function() {
        return {
            place: {
                zones: []
            },
            inspection: {
                company_address: {},
                place_address: {},
                exceeded_zones: [],
                dosage_table: [],
                answers: [],
                properties_casting: [],
                properties: [],
                problems: [],
            },
            selectedAdds: 'all',
            workers: [],
            dev_types: [],
            pests: [],
            pestslist: [],
            zones: [],
            devices: [],
            selectedDevices: [],
            device_categories: [],
            devcats_lookup: {},
            devices_loaded: false,
            act_levels: [this.$t('devices.no_activity_short'), this.$t('devices.low_activity_short'), this.$t('devices.average_activity_short'), this.$t('devices.high_activity_short'), this.$t('devices.very_high_activity_short')],
            long_act_levels: [this.$t('devices.no_activity'), this.$t('devices.low_activity'), this.$t('devices.average_activity'), this.$t('devices.high_activity'), this.$t('devices.very_high_activity')],
            problem_kinds: ["", this.$t('inspection.not_found'), this.$t('inspection.unreadable_code'), this.$t('inspection.unavailable'), this.$t('inspection.need_remove'), this.$t('inspection.destroyed'), this.$t('inspection.temporary_disabled')],
            question: "",
            cancelText: "",
            confirmText: "",
            callback: null,
            edited: true,
            saving: false,
            criteria_dict: {}
        }
    },
    beforeRouteLeave (to, from , next) {
      if(this.edited){
          this.question = this.$t('menu.save_question')
          this.cancelText = this.$t('menu.buttons.save_cancel')
          this.confirmText = this.$t('menu.buttons.save_changes')
          this.$refs.question.open();
          this.callback = next;
      }else{
        next()
      }
    },
    props: {company_name: String, company_address: Object},
    created() {
        this.load_inspection();
    },
    methods: {
        async load_inspection() {
            var response = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/devices/t/' + moment(this.inspection.date).unix() + '.json');
            this.devices = response.data;
            var place_response = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json');
            this.place = place_response.data;

            if(this.$route.params.inspection_id == 'new'){
                var criteria = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/criteria.json');
                for (var i = criteria.length - 1; i >= 0; i--) {
                  var zone = criteria[i];
                  this.criteria_dict[zone.zone_id]={};
                  for (var j = zone.categories.length - 1; j >= 0; j--) {
                    this.criteria_dict[zone.zone_id][zone.categories[j].id] = zone.categories[j];
                  }
                }
                var properties_casting = [];
                var groups = _.values(_.groupBy(this.devices, function(dev) {
                    return "" + dev.zone_id + ":"+ dev.dev_category
                }));
                for (var i = 0; i < groups.length; i++) {
                    var group = groups[i];
                    var firstdevice = group[0];
                    var devicesingroup = _.map(
                        group,
                        function(dev){
                            return {
                                number: dev.number,
                                device_id: dev.id,
                                conditions: null,
                            }
                        }
                    );
                    properties_casting.push({
                        zone_id: firstdevice.zone_id,
                        zone_name: firstdevice.zone_name,
                        device_category: firstdevice.device_category,
                        items: devicesingroup
                    })
                }
                this.inspection = {
                    worker_signature: "",
                    properties: [],
                    problems: [],
                    properties_casting: [],
                    company_address: this.company_address,
                    company_name: this.company_name,
                    worker_id: app.app.worker_id,
                    place_name: this.place.name,
                    place_address: this.place.address,
                    criteria: criteria.data,
                    media: [],
                    exceeded_zones: [],
                    dosage_table: [],
                    answers: [],
                    editable: true,
                    date: moment().format("YYYY-MM-DD"),
                    safety_conditions: 0,
                    recommendations_resolved_ids: [],
                    inspection_pests: []
                };
            }else{
                var response = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.$route.params.inspection_id + '.json');
                this.inspection = response.data;
                this.inspection.properties = [];
                this.inspection.problems = [];
                this.inspection.media = _.cloneDeep(this.inspection.photos);
                var probPhotos = _.groupBy(this.inspection.problem_photos, 'device_id');
                var propPhotos =  _.groupBy(this.inspection.property_photos, 'device_id');
                for(var pc of _.flatten(_.map(this.inspection.properties_casting, 'items'))){
                   pc.problem_media = probPhotos[pc.device_id] || [];
                   pc.property_media = propPhotos[pc.device_id] || [];
                }
            }
            if (this.inspection.worker_signature.indexOf('data:image/png;base64,') == -1) {
                this.inspection.worker_signature = 'data:image/png;base64,' + this.inspection.worker_signature
            }
            for (var i = this.inspection.properties_casting.length - 1; i >= 0; i--) {
                if (this.inspection.properties_casting[i].zone_id != null) {
                    this.zones.push({ value: this.inspection.properties_casting[i].zone_id, name: this.inspection.properties_casting[i].zone_name })
                }
                this.device_categories.push({ value: this.inspection.properties_casting[i].device_category.id, name: this.inspection.properties_casting[i].device_category.name })
            }
            response = await axios.get('/workers.json');
            this.workers = response.data.map(function(worker) {
                return { name: worker.name + " " + worker.surname, value: worker.id };
            });
            response = await axios.get('/pests.json');
            this.pests = response.data
            this.pestslist = response.data;
            this.pestsdict = _(response.data).map(v=>[v.id, v.name]).fromPairs().value()
            response = await axios.get('/dev_types.json');
            this.dev_types = _.keyBy(response.data, 'id')
            this.devcats_lookup = _.keyBy(response.data, 'device_category_id');
            response = await axios.get('/substances.json');
            this.substances = response.data
            this.devices_loaded = true;
            this.recommendations = _.filter(this.inspection.recommendations, { 'editable': false });
            this.inspection.recommendations = _.filter(this.inspection.recommendations, { 'editable': true });
        },
        onlyCheckedOrReported(items) {
            return _.filter(items, (item) => {
                return Number.isInteger(item.conditions) || Number.isInteger(item.kind)
            });
        },
        setFile: function(doc, name, file) {
            var that = this;

            doc.image = file[0];
            var reader = new FileReader();

            reader.onload = function(event) {
                var dataUri = event.target.result;
                var img = document.getElementsByClassName('photo' + that.inspection.media.indexOf(doc))[0];

                img.src = dataUri;
            };
            reader.onerror = function(event) {
            };
            reader.readAsDataURL(doc.image);
            if (file.length > 1) {
                for (var i in _.range(file.length)) {
                    if (i > 0) {
                        var ndoc = { timestamp: _.now() };
                        ndoc.image = file[i];
                        var reader = new FileReader();

                        reader.onload = function(event) {
                            var dataUri = event.target.result;
                            var img = document.getElementsByClassName('photo' + that.inspection.media.indexOf(ndoc))[0];
                            img.src = dataUri;
                        };
                        reader.onerror = function(event) {
                        };
                        reader.readAsDataURL(ndoc.image);

                        this.inspection.media.push(ndoc)
                    }
                }
            }

        },
        methodForDevice(device) {
            if(_.isUndefined(this.criteria_dict[""+device.zone_id])) return "standard";
            var crit = this.criteria_dict[""+device.zone_id][""+device.dev_category];
            if(_.isUndefined(crit)) return "standard";
            return crit.method;
        },
        cancelClicked: function(){
            this.callback();
        },
        addPhoto: function(){
            this.inspection.media.push({notices: ""});
            this.$forceUpdate();
        },
        removeProperty: function(item){
            item._destroy = true;
            this.$forceUpdate();
        },
        removePhoto(photo) {
            if (_.isUndefined(photo.id)) {
                this.inspection.media.splice(this.inspection.media.indexOf(photo), 1)
            } else {
                photo._destroy = true;
            }
             this.$forceUpdate();
        },
        removeAnswer(answer){
            if (_.isUndefined(answer.id)) {
                this.inspection.answers.splice(this.inspection.answers.indexOf(answer), 1)
            } else {
                answer._destroy = true;
            }
             this.$forceUpdate();
        },
        removeInspectionPest: function(inspectionspest){
            if (_.isUndefined(inspectionspest.id)) {
                this.inspection.inspection_pests.splice(this.inspection.inspection_pests.indexOf(inspectionspest), 1)
            } else {
                inspectionspest._destroy = true;
            }
             this.$forceUpdate();
        },
        addDevices: function(){
            if (this.selectedAdds == 'all') {
                for (var i = this.leftDevices.length - 1; i >= 0; i--) {
                    var leftdev = this.leftDevices[i];
                    this.addDevice(leftdev);
                }
            } else if (this.selectedAdds == 'selected') {
                for (var i = this.selectedDevices.length - 1; i >= 0; i--) {
                    var devid = this.selectedDevices[i];
                    var leftdev = _.keyBy(this.leftDevices, 'id')[devid];
                    this.addDevice(leftdev);
                }
                this.selectedDevices = [];
            } else if (this.selectedAdds.indexOf("allFromDeviceCategory") > -1) {
                var leng = "allFromDeviceCategory".length;
                var dta = this.selectedAdds.slice(leng, this.selectedAdds.length);
                var from_zone = _.filter(this.leftDevices, (dev) => {
                    return ("" + dev.dev_category) == dta;
                })
                for (var i = from_zone.length - 1; i >= 0; i--) {
                    var devid = from_zone[i].id;
                    var leftdev = _.keyBy(this.leftDevices, 'id')[devid];
                    this.addDevice(leftdev);
                }

            } else if (this.selectedAdds.indexOf("allFromZone") > -1) {
                var leng = "allFromZone".length;
                var zona = this.selectedAdds.slice(leng, this.selectedAdds.length);
                var from_zone = _.filter(this.leftDevices, (dev) => {
                    return ("" + dev.zone_id) == zona;
                })

                for (var i = from_zone.length - 1; i >= 0; i--) {
                    var devid = from_zone[i].id;
                    var leftdev = _.keyBy(this.leftDevices, 'id')[devid];
                    this.addDevice(leftdev);
                }
            }
        },
        addRecommendation(){
            this.inspection.recommendations.push({
                "editable": true,
                "kind": "fixing"
            });
            this.$forceUpdate();
        },
        rowSaved(row){
            var existingProperty = _.find(this.inspection.properties, {'device_id': row.device.id});
            var existingProblem = _.find(this.inspection.problems, {'device_id': row.device.id});
            var deviceRow = _.find(_.flatten(_.map(this.inspection.properties_casting, 'items')), {'device_id': row.device.id});
            if(row.property != null){
                if(existingProperty == undefined)this.inspection.properties.push(row.property);
                deviceRow.conditions = row.property.conditions;
                deviceRow.safety_conditions = row.property.safety_conditions;
                deviceRow.cleanup = row.property.cleanup;
                deviceRow.notices = row.property.notices;
                deviceRow.pest_ids = row.property.pest_ids;
                deviceRow.substance_ids = row.property.substance_ids;
            }
            if(row.problem != null){
                if(existingProblem == undefined) this.inspection.problems.push(row.problem);
                deviceRow.kind = row.problem.kind;
                console.log(row.problem);
                deviceRow.inactivate_cause = row.problem.inactivate_cause;
            }
            this.$forceUpdate();
        },
        addDevice(leftdev){
            var anyprop = false;
            for (var j = this.inspection.properties_casting.length - 1; j >= 0; j--) {
                var propcasting = this.inspection.properties_casting[j];
                var prop = _.find(propcasting.items, (dev) => { return dev.device_id == leftdev.id; });
                if (prop != undefined) {
                    prop.conditions = 0;
                    prop.safety_conditions = 3;
                    prop.media = [];
                    prop.cleanup = true;
                    prop.number = leftdev.number;
                    prop.code = leftdev.code;
                    prop.device_id = leftdev.id;
                    prop.substance_replaced = true;
                    prop.method = this.methodForDevice(leftdev);
                    prop.dev_type_id = leftdev.dev_type_id
                    prop.pest_ids = []
                    prop.substance_ids = _.map(leftdev.last_dosage, 'substance_id')
                    prop.dosages = _.chain(leftdev.last_dosage).map(
                        obj => _.defaults({}, obj, {'replaced': 0, 'new_dose': 0})
                    ).value() || []
                    prop.property_pests = []
                    anyprop = true
                }
            }
            if(anyprop == false){
                var prop = {};
                prop.media = [];
                prop.number = leftdev.number;
                prop.code = leftdev.code;
                prop.device_id = leftdev.id;
                prop.dev_type_id = leftdev.dev_type_id
                prop.dosages =  _.chain(leftdev.last_dosage).map(
                    obj => _.defaults({}, obj, {'replaced': 0, 'new_dose': 0})
                ).value() || []
                prop.substance_ids = _.map(leftdev.last_dosage, 'substance_id')
                prop.device = leftdev
                prop.device_category = {}
                var dc = this.devcats_lookup[leftdev.dev_category];
                var groupa = _.find(this.inspection.properties_casting, function(ppc){ return ppc.device_category.id == leftdev.dev_category && leftdev.zone_id == ppc.zone_id})
                if(_.isUndefined(groupa)){
                    this.inspection.properties_casting.push({device_category: {name: dc.category_name, id: leftdev.dev_category}, zone_id: leftdev.zone_id, zone_name: leftdev.zone_name, items: [prop]});
                }else{
                    groupa.items.push(prop);
                }
            }
        },
        removeRecommendation(recommendation){
            if (_.isUndefined(recommendation.id)) {
                this.inspection.recommendations.splice(this.inspection.recommendations.indexOf(recommendation), 1)
            } else {
                recommendation._destroy = true;
            }
            this.$forceUpdate();
        },
        recommendationSaved(){
            this.$forceUpdate();
        },
        toFormData(formData, prefix, obj) {
            if (_.isUndefined(obj) == false && _.isNull(obj) == false) {
                for (var key of Object.keys(obj)) {
                    if (_.isString(obj[key]) || _.isNumber(obj[key]) || _.isBoolean(obj[key])) formData.append(prefix + '[' + key + ']', obj[key]);
                    else if (_.isArray(obj[key])) {
                        for (var c of Object.keys(obj[key])) {
                            if (_.isString(obj[key][c]) || _.isNumber(obj[key][c])) formData.append(prefix + '[' + key + '][]', obj[key][c]);
                            else if (_.isObject(obj[key][c])) this.toFormData(formData, prefix + '[' + key + '_attributes][' + c + ']', obj[key][c]);
                        }
                        if(_.isEmpty(obj[key])){
                            formData.append(prefix + '[' + key + '][]', "");
                        }
                    } else if (obj[key] instanceof File){
                        formData.append('' + prefix + '[' + key + ']', obj[key], obj[key].name)
                    } else if (_.isObject(obj[key])) this.toFormData(formData, '' + prefix + '[' + key + '_attributes]', obj[key])
                }
            }
        },
        saveInspection(){
            var that = this;
            if(this.saving == false){
                this.saving = true;
                const formData = new FormData();
                this.toFormData(formData, 'inspection', this.inspection)
                if (this.inspection.id) {
                    axios.put('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.inspection.id + '.json', formData).then(function() {
                        that.edited = false
                        that.saving = false
                        that.$router.push('/customers/' + that.$route.params.customer_id + '/places/' + that.$route.params.place_id + '/inspections/' + that.inspection.id )
                    });
                } else {
                    axios.post('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections.json', formData).then(function(response) {
                        that.edited = false
                        that.saving = false
                        var inspection_id = response.data.id;
                        that.$router.push('/customers/' + that.$route.params.customer_id + '/places/' + that.$route.params.place_id + '/inspections/' + inspection_id )
                    });
                }
            }
        }
    },
    computed: {
        groups() {
            return _.groupBy(this.inspection.summary, 'zone_name');
        },
        pestGroups() {
            return _.groupBy(this.pests, 'group_name');
        },
        substanceGroups() {
            var grupy = {};
            for (var i = this.substances.length - 1; i >= 0; i--) {
                var sub = this.substances[i];
                for (var j = sub.group.length - 1; j >= 0; j--) {
                    if (_.isUndefined(grupy[sub.group[j]])) grupy[sub.group[j]] = [];
                    grupy[sub.group[j]].push(sub);
                }
                if(sub.group.length == 0){
                    if (_.isUndefined(grupy[""])) grupy[""] = [];
                    grupy[""].push(sub);
                }
            }
            return grupy;
        },
        property_groups() {
            return _.groupBy(this.inspection.properties_casting, 'zone_name')
        },
        leftDevices() {
            var inspected_devices = [];
            for (var i = this.inspection.properties_casting.length - 1; i >= 0; i--) {
                var propcasting = this.inspection.properties_casting[i];
                var propo =  (propcasting.items || [propcasting]);
                for (var j = propo.length - 1; j >= 0; j--) {
                    var dev = propo[j];
                    if (Number.isInteger(dev.conditions)) {
                        inspected_devices.push(dev.device_id);
                    }
                }
            }
            return this.devices.filter((device) => { return inspected_devices.indexOf(device.id) == -1 && device.active });
        },
        leftDeviceZones() {
            var zone_dict = _.keyBy(this.place.zones, 'id');
            return _.map(_.compact(_.uniq(this.leftDevices.map((dev) => { return dev.zone_id }))), (zid) => { return zone_dict[zid] })
        },
        leftDeviceCategories() {
            var devcat_dict = _.keyBy(this.device_categories, 'value')
            return _.compact(_.map(_.compact(_.uniq(this.leftDevices.map((dev) => { return dev.dev_category }))), (dcid) => { return devcat_dict[dcid] }))
        },
        leftDevicesOptions() {
            return _.map(this.leftDevices, (dev) => {
                return { name: dev.number, value: dev.id };
            })
        }
    }

}
</script>
<style scoped>
tr:last-child {
    border-bottom: none;
}

tr {
    border: none;
}

.hidden {
    display: none;
}

.addresses,
.addresses th,
.addresses td,
.properties,
.properties th,
.properties td {
    border: 1px solid rgba(0, 0, 0, 1);
    padding-left: 5px;
}

.properties,
.properties th,
.properties td {
    font-size: 10px;
    padding: 5px 5px;
    text-align: center;
}

tr>.current {
    border-left: 2px solid black;
}

tr>.current~.current {
    border: 1px solid rgba(0, 0, 0, 1);
}

.bolded-top {
    border-top: 2px solid black !important;
}

.bolded-left {
    border-left: 2px solid black !important;
}

.bolded-right {
    border-right: 2px solid black !important;
}

.bolded-bottom {
    border-bottom: 2px solid black !important;
}

tr:last-child>.current {
    border-bottom: 2px solid black !important;
}

th {
    border-bottom: 2px solid rgba(0, 0, 0, 0.12);
    font-weight: initial;
    padding-left: 0px;
}

td {
    padding-left: 0px;
}



.btn {
    margin-bottom: 5px;
}

.col p {
    margin: .7666666667rem 0 0.46rem 0;
}

select,
input {
    display: block;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
}

/deep/ .solidgreen {
    background-color: #00CC66 !important;
    border-color: #00CC66;
    color: white;
    border-width: 1px;
    border-style: solid;
}

.btn-red:hover {
    background-color: #c22026;
}

.emptygreen {
    border-radius: 4px !important;
    border-width: 2px !important;
    border-style: solid !important;
    border-color: #00CC66 !important;
    padding: 2px;
    margin: 2px;
    background-color: white;
    color: black;
    line-height: 24px;
}

.emptyred {
    border-radius: 4px !important;
    border-width: 2px !important;
    border-style: solid !important;
    border-color: #C22026 !important;
    padding: 2px;
    margin: 2px;
    background-color: white;
    color: black;
    line-height: 24px;
}

.emptygray {
    border-radius: 4px !important;
    border-width: 2px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding: 2px;
    margin: 2px;
    background-color: white;
    color: black;
    line-height: 24px;
}

.btn-small {
    color: black;
    border-radius: 8px;
}

.removephoto {
    vertical-align: top;
    float: right;
    background-color: black;
    border: none;
    border-radius: 15px;

}

.removephoto i {
    color: white;
}

/deep/ ul#dropdownselectordevslist li:not(.searchterm) {
    column-count: 4;
    display: inline-block;
    width: 60px;
}

/deep/ ul#dropdownselectordevslist [type="checkbox"]:checked+span:not(.lever):before {
    border: none !important;
}

/deep/ ul#dropdownselectordevslist [type="checkbox"]:checked+span:not(.lever) {
    color: red;
    padding-left: 0px;
}

/deep/ ul#dropdownselectordevslist [type="checkbox"]+span:not(.lever) {
    padding-left: 0px;
}

/deep/ ul#dropdownselectordevslist [type="checkbox"]+span:not(.lever):before {
    border: none !important;
}

.red {
    background-color: #C22026 !important;
    border-color: #C22026 !important;
}
.resolved td {
    text-decoration: line-through;
}
</style>
